var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","right":"15px","top":"10px","cursor":"pointer"},on:{"click":_vm.close}},[_c('img',{attrs:{"src":"https://oss2.1dq.com/app/img/close.png","width":"25","height":"25"}})])}
var staticRenderFns = []

export { render, staticRenderFns }